module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('m-header', {
    attrs: {
      "title": "新增收货地址",
      "backFn": "1"
    },
    on: {
      "back": function($event) {
        _vm.show1 = true
      }
    }
  }), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "1.8rem",
      "label-margin-right": ".2rem",
      "label-align": "left"
    }
  }, [_c('x-input', {
    staticClass: "input",
    attrs: {
      "title": "收件人",
      "placeholder": "收货人姓名"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "联系方式",
      "type": "tel",
      "placeholder": "手机号",
      "max": 11
    },
    model: {
      value: (_vm.form.mobileNumber),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobileNumber", $$v)
      },
      expression: "form.mobileNumber"
    }
  }), _vm._v(" "), _c('x-address', {
    attrs: {
      "title": "所在地区",
      "list": _vm.addressData,
      "value-text-align": "left"
    },
    model: {
      value: (_vm.form.areaCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "areaCode", $$v)
      },
      expression: "form.areaCode"
    }
  }), _vm._v(" "), _c('x-textarea', {
    attrs: {
      "title": "详细地址",
      "placeholder": "请填写详细地址",
      "show-counter": false,
      "rows": 1
    },
    model: {
      value: (_vm.form.location),
      callback: function($$v) {
        _vm.$set(_vm.form, "location", $$v)
      },
      expression: "form.location"
    }
  }), _vm._v(" "), _c('x-switch', {
    attrs: {
      "title": "设为默认地址"
    },
    model: {
      value: (_vm.form.default),
      callback: function($$v) {
        _vm.$set(_vm.form, "default", $$v)
      },
      expression: "form.default"
    }
  })], 1), _vm._v(" "), _c('footer', {
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('confirm', {
    attrs: {
      "confirm-text": "确定",
      "cancel-text": "取消"
    },
    on: {
      "on-cancel": function($event) {
        _vm.show1 = false
      },
      "on-confirm": function($event) {
        _vm.$router.go(-1)
      }
    },
    model: {
      value: (_vm.show1),
      callback: function($$v) {
        _vm.show1 = $$v
      },
      expression: "show1"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("确定放弃编辑吗?")])]), _vm._v(" "), _c('alert', {
    attrs: {
      "title": "提示"
    },
    model: {
      value: (_vm.isAlert),
      callback: function($$v) {
        _vm.isAlert = $$v
      },
      expression: "isAlert"
    }
  }, [_vm._v("手机号码有误，请重新填写")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0785360"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddAddress/AddAddress.vue
// module id = 616
// module chunks = 0